import { createSlice } from "@reduxjs/toolkit";
import { setAuthToken, setRefreshToken, clearAuthTokens } from "lib/api";

export const sliceAuthUser = createSlice({
  name: "authUser",
  initialState: {
    data: {},
    token: null,
    refreshToken: null,
  },
  reducers: {
    fetched: (state, { payload }) => {
      const { user, token, refreshToken } = payload?.data || {};
      if (user !== undefined) state.data = user || {};
      if (token !== undefined) state.token = token;
      if (refreshToken !== undefined) state.refreshToken = refreshToken;
    },
    updated: (state, { payload }) => {
      const patch = payload?.data;
      if (!patch) return;
      state.data = state.data ? { ...state.data, ...patch } : { ...patch };
    },
    logout: (state) => {
      state.data = {};
      state.token = null;
      state.refreshToken = null;
    },
  },
});

const { fetched, updated, logout } = sliceAuthUser.actions;

export const SetAuthUserData = (data) => (dispatch) => {
  if (!data) throw new Error("missing Data parameter");
  if (data.token) setAuthToken(data.token);
  if (data.refreshToken) setRefreshToken(data.refreshToken);
  dispatch(fetched({ data }));
};

export const UpdateAuthUserData = (data) => async (dispatch) => {
  if (!data) throw new Error("missing Data parameter");
  dispatch(updated({ data }));
};

export const LogoutUser = () => (dispatch) => {
  clearAuthTokens();
  dispatch(logout({}));
};

export const selectAuthUser = (state) => state.AuthUser?.data;
export const selectAuthToken = (state) => state.AuthUser?.token;
export const selectRefreshToken = (state) => state.AuthUser?.refreshToken;
export const selectIsAuthenticated = (state) =>
  Boolean(state.AuthUser?.token);

export default sliceAuthUser.reducer;
